import { render, staticRenderFns } from "./userControl.vue?vue&type=template&id=52070030&scoped=true"
import script from "./userControl.vue?vue&type=script&lang=js"
export * from "./userControl.vue?vue&type=script&lang=js"
import style0 from "./userControl.vue?vue&type=style&index=0&id=52070030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52070030",
  null
  
)

export default component.exports